<template>
  <LegalDocumentPage :document="termsOfService" @close="$emit('close')" />
</template>

<script setup lang="ts">
import { termsOfService } from "../../content/legalDocuments";
import LegalDocumentPage from "../LegalDocumentPage.vue";

defineEmits<{
  (event: "close"): void;
}>();
</script>
